import {css} from "@emotion/react";

export const root = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    height: 100%;
`;

